import React,{ useEffect, useMemo } from "react";
import useStyles from 'isomorphic-style-loader/useStyles'
import classes from "./style.module.scss"
import { Iconfont } from "../../../../components/icon/iconfont";
import { IMAGE_GEEKO_LTD } from "../../../../../constants";

import withSouce from "../../../../../client/hocs/source-scoll";
import { useQuery } from "../../../../hooks/common";

import useOpenWindow  from '../../../../hooks/open-window'
import ProductRankModal from "../../fragments/ranking-list/index";


const BestSellers = withSouce(props =>{
    const { innerRef, productRank, moreReviewModalShow, sensors, productCategoyName } = props;

    return <div 
        className={classes.ProductRank} 
        onClick={moreReviewModalShow} 
        ref={innerRef}
        data-title={sensors?.resourcepage_title}
        data-position={sensors?.resource_position}
        data-type={sensors?.resource_type}
        data-content={sensors?.resource_content}
    >
        <div>
            <img src={`${IMAGE_GEEKO_LTD}${productRank?.icon}`} alt="Best Sellers" />
        </div>
        <div className={classes.ProductRankName}>
            <span>in {productCategoyName}</span>
        </div>

        <div>
            <Iconfont className={classes.Icon}>&#xe694;</Iconfont>
        </div>
    </div>
});

export default props =>{
    useStyles(classes);
    const { productCategoyName, productRank } = props;

    const {show: showModal, setShow: setShowModal} = useOpenWindow('product-rank')


    const query = useQuery();

    useEffect(()=>{
        if(query?.showBest){
            moreReviewModalShow();
        }
    },[]);

    const moreReviewModalShow = () => {
        setShowModal(true)
    }

    const moreReviewModalHide = () => {
        setShowModal(false)
    }
    
    let sensors = useMemo(() =>{
        return {
            resourcepage_title: "product",
            resource_position: "1",
            resource_type: "3",
            resource_content: `in ${productRank?.productCategoyEnName}`
        }
    },[])

    return (
        <div className={classes.ProductBestSellers}>
            <BestSellers moreReviewModalShow={moreReviewModalShow} productRank={productRank} productCategoyName={productCategoyName} sensors={sensors} />

            <ProductRankModal {...props} onClose={moreReviewModalHide} showModal={showModal} sensors={sensors} />
        </div>
    )
}